import { Filesystem, Directory } from "@capacitor/filesystem";
import { FileOpener } from "@awesome-cordova-plugins/file-opener";
import { Capacitor } from "@capacitor/core";
import axios from "@/plugins/axios";
import { appOrigin } from "@/utils/basics";
export const file = {
  methods: {
    async downloadFile(id, path, mimeType) {
      if (Capacitor.isNativePlatform()) {
        this.$store.commit("setShowLoading", true);
        const response = await axios.post(
          "?Mode=General&Function=DownloadFile",
          {
            Id: id,
            Base64: true,
          }
        );
        this.$store.commit("setShowLoading", true);
        const writeFileResult = await Filesystem.writeFile({
          path: path,
          data: response.data,
          directory: Directory.External,
          // encoding: Encoding.UTF8,
        });
        await FileOpener.open(writeFileResult.uri, mimeType);
        this.$store.commit("setShowLoading", false);
      } else {
        window.open(
          appOrigin + "/arag/api/?Mode=General&Function=DownloadFile&Id=" + id,
          "_blank"
        );
      }
    },
  },
};
